import React, { Component } from "react";
import { getSocialSecurityWageAll } from '../../../../appRedux/actions/vendorAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import "react-table/react-table.css";
import CircularProgress from "../../../../components/CircularProgress";
import WageLimitForm from '../../../../Forms/AddWageLimitForm';
import SearchBox from '../../../../components/SearchBox';
import Button from '@material-ui/core/Button';
import "react-toastify/dist/ReactToastify.css";
import { Table } from 'antd';

import "../../styles.css";
import "./WagesList.css";
let compareByAlph = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}


class WagesListPage extends Component {

    constructor(props) {

        super(props);

        let column = [{
            title: 'Year',
            dataIndex: 'socialSecurityWageYear',
            className: 'table-heading',
            sorter: false,
            width: 200,
            sorter: (a, b) => compareByAlph(a.socialSecurityWageYear, b.socialSecurityWageYear),
        }, {
            title: 'Wage Limit Amount',
            dataIndex: 'socialSecurityWageLimit',
            className: 'table-heading',
            sorter: false,
            width: 200,
            sorter: (a, b) => compareByAlph(a.socialSecurityWageLimit, b.socialSecurityWageLimit),
        }];

        this.state = {
            pageSize: 50,
            currentPage: 1,
            totalRowsInTable: 0,
            fieldName: 'socialSecurityWageYear',
            sortFormat: 'A',
            columns: column,
            loading: false,
            searchText: '',
            search: false,
            selectedWageLimit: '',
            isOpen: false,
            isAddOpen: false,
            isEdit: false,
            companyId: '',
            Columns: column,
            wagesList: []
        }
    }

    componentDidMount() {
        this.listData();
    }

    listData() {
        this.setState({ loading: true }, () => {
            this.props.getSocialSecurityWageAll();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.wagesList !==undefined && nextProps.wagesList !== this.props.wagesList) {
            this.setState({ loading: false, wagesList: nextProps.wagesList.returnObject });
        }
        //if (nextProps.reload == this.props.reload) { this.listData(); }
    }

    handleCancel = (value) => {
        this.setState({ isOpen: false, isEdit: false, isAddOpen: false });
        if (value && value == 'yes') { this.listData(); }
    };

    handleAddModal = () => {
        this.setState({ isAddOpen: true, isEdit: false });
    }

    handleEditModal = (record) => {
        var id = record.socialSecurityWageID;
        var data = this.state.wagesList;
        if (id != 0) {
            const selectedWageLimit = _.find(data, { socialSecurityWageID: id });
            this.setState({ isEdit: true, isAddOpen: true, selectedWageLimit: selectedWageLimit });
        }
    }


    handleSave = (state) => {
        this.setState({
            isOpen: state,
            isEdit: state,
            isAddOpen: false
        });
    }


    render() {

        let { searchText, wagesList, columns } = this.state;
        var wages = wagesList;
        if (searchText) {
            wages = (wagesList || []).filter(obj => {
                if (obj.socialSecurityWageYear !== null && obj.socialSecurityWageLimit !== null) {
                    if (obj.socialSecurityWageYear.toString().toLowerCase().includes(searchText.toLowerCase()) === true || obj.socialSecurityWageLimit.toString().toLowerCase().includes(searchText.toLowerCase()) === true) {
                        return obj;
                    }
                }
            });
        }
        let filteredData = (wages || []).map((d, index) => ({
            key: d.socialSecurityWageID,
            ...d
        }))

        return (
            <div className="wages-limit-page">
                {this.state.loading == false ?
                    <WageLimitForm
                        isEdit={this.state.isEdit}
                        handleSave={this.handleSave}
                        visible={this.state.isAddOpen}
                        handleCancel={this.handleCancel}
                        selectedItem={this.state.selectedWageLimit}
                    />
                    : ''}
                {this.state.loading
                    ?
                    <div className="wages-limit-loader">
                        <CircularProgress />
                    </div>
                    :
                    <React.Fragment>
                        <div className="wages-limit-header">
                            <h2 className="wages-limit-title">Wages Limit</h2>
                            <div className="wages-limit-header-actions">
                                <SearchBox
                                    styleName="d-none d-lg-block"
                                    placeholder="Search... "
                                    value={this.state.searchText}
                                    onChange={(e) => { this.setState({ searchText: e.target.value }) }}
                                    style={{ background: '#eeeeeeb8' }}
                                />
                                <Button variant="contained" color="primary" onClick={this.handleAddModal} >
                                    Add Wages
                                </Button>
                            </div>
                        </div>
                        <div className="wages-limit-card">
                            <div className="wages-limit-table-wrap">
                                {/* No `scroll` prop: the table grows with its rows and the window scrolls.
                                    `columns` reads this.state.Columns (capital C) on purpose; renaming breaks the table. */}
                                <Table
                                    className="table-layout"
                                    columns={this.state.Columns}
                                    dataSource={filteredData}
                                    // rowClassName={ (record) =>  this.state.selectedItemKey == record.key  ? 'data-row selected' : 'data-row'  }
                                    bordered={true}
                                    size={"small"}
                                    onRow={(record, index) => ({
                                    // Only double click opens the editor, as before.
                                      onDoubleClick: () => this.handleEditModal(record),
                                    })}
                                    //   onChange={this.handleTableChange}
                                    loading={this.state.loading}
                                    pagination={false}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        wagesList: state.vendors.wagesList,
        reload: state.vendors.reload
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getSocialSecurityWageAll
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(WagesListPage);